interface Props {
}

export default function WizardAppPreview(props: Props) {
    return <svg width="100%" height="100%" viewBox="0 0 334 682" version="1.1" xmlns="http://www.w3.org/2000/svg"
        style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: "2"
        }}>
        <rect id="ArtBoard1" x="0" y="0" width="334" height="682" style={{ fill: "none" }} />
        <clipPath id="_clip1">
            <rect x="0" y="0" width="334" height="682" />
        </clipPath>
        <g clipPath="url(#_clip1)">
            <g>
                <rect x="331" y="164" width="3" height="46" style={{ fill: "a8a8a8" }} />
                <rect x="331" y="257" width="3" height="96" style={{ fill: "a8a8a8" }} />
                <path d="M297.041,30.41l3.3,0l0,-3.3l-3.3,0l0,3.3Zm-0.55,5.5c-0.156,0 -0.286,-0.053 -0.392,-0.158c-0.105,-0.105 -0.158,-0.236 -0.158,-0.392l0,-8.8c0,-0.156 0.053,-0.286 0.158,-0.392c0.105,-0.105 0.236,-0.158 0.392,-0.158l1.1,0l0,-0.55c0,-0.156 0.053,-0.286 0.158,-0.392c0.105,-0.105 0.236,-0.158 0.392,-0.158l1.1,0c0.156,0 0.286,0.053 0.392,0.158c0.105,0.105 0.158,0.236 0.158,0.392l0,0.55l1.1,0c0.156,0 0.286,0.053 0.392,0.158c0.105,0.105 0.158,0.236 0.158,0.392l0,8.8c0,0.156 -0.053,0.286 -0.158,0.392c-0.105,0.105 -0.236,0.158 -0.392,0.158l-4.4,0Z"
                    style={{
                        fill: "#a8a8a8",
                        fillRule: "nonzero",
                    }}
                />
                <path d="M273.765,35.91l-7.765,-7.765c1.025,-1.046 2.208,-1.847 3.551,-2.402c1.343,-0.555 2.747,-0.833 4.214,-0.833c1.467,0 2.871,0.278 4.214,0.833c1.343,0.555 2.526,1.356 3.551,2.402l-7.765,7.765Z"
                    style={{
                        fill: "#a8a8a8",
                        fillRule: "nonzero",
                    }}
                />
                <g transform="matrix(14,0,0,14,60.430664,35.773437)">
                </g>
                <path d="M280,35.91l11,0l0,-11l-11,11Z" style={{ fill: "a8a8a8" }} />
                <path d="M233,656c0,1.656 -1.344,3 -3,3l-129,0c-1.656,0 -3,-1.344 -3,-3c0,-1.656 1.344,-3 3,-3l129,0c1.656,0 3,1.344 3,3Z"
                    style={{ fill: "#dadada", }}
                />
                <path d="M331,35l0,612c0,19.317 -15.683,35 -35,35l-261,0c-19.317,0 -35,-15.683 -35,-35l0,-612c0,-19.317 15.683,-35 35,-35l261,0c19.317,0 35,15.683 35,35Z"
                    style={{
                        fill: "#fff",
                        fillOpacity: "0.22",
                    }}
                />
                <path d="M331,35l0,612c0,19.317 -15.683,35 -35,35l-261,0c-19.317,0 -35,-15.683 -35,-35l0,-612c0,-19.317 15.683,-35 35,-35l261,0c19.317,0 35,15.683 35,35Zm-10,0c0,-13.798 -11.202,-25 -25,-25l-261,0c-13.798,0 -25,11.202 -25,25l0,612c0,13.798 11.202,25 25,25l261,0c13.798,0 25,-11.202 25,-25l0,-612Z"
                    style={{
                        fill: "#a8a8a8"
                    }}
                />
            </g>
        </g>
    </svg>;
}